import { vocab } from './vocab'

/**
 * ISO 3166-1 alpha-2 subset: Europe plus the major markets an asset manager's
 * portfolio realistically touches. Extend by appending; never repurpose a code.
 */
export const COUNTRIES = vocab(
  [
    'AT',
    'BE',
    'BG',
    'CH',
    'CY',
    'CZ',
    'DE',
    'DK',
    'EE',
    'ES',
    'FI',
    'FR',
    'GB',
    'GR',
    'HR',
    'HU',
    'IE',
    'IS',
    'IT',
    'LI',
    'LT',
    'LU',
    'LV',
    'MT',
    'NL',
    'NO',
    'PL',
    'PT',
    'RO',
    'SE',
    'SI',
    'SK',
    'UA',
    'TR',
    'US',
    'CA',
    'MX',
    'BR',
    'CL',
    'AR',
    'PE',
    'CO',
    'CN',
    'HK',
    'TW',
    'JP',
    'KR',
    'SG',
    'IN',
    'ID',
    'MY',
    'TH',
    'PH',
    'VN',
    'AU',
    'NZ',
    'ZA',
    'NG',
    'KE',
    'GH',
    'EG',
    'MA',
    'AE',
    'SA',
    'QA',
    'IL',
  ],
  {
    AT: 'Austria',
    BE: 'Belgium',
    BG: 'Bulgaria',
    CH: 'Switzerland',
    CY: 'Cyprus',
    CZ: 'Czechia',
    DE: 'Germany',
    DK: 'Denmark',
    EE: 'Estonia',
    ES: 'Spain',
    FI: 'Finland',
    FR: 'France',
    GB: 'United Kingdom',
    GR: 'Greece',
    HR: 'Croatia',
    HU: 'Hungary',
    IE: 'Ireland',
    IS: 'Iceland',
    IT: 'Italy',
    LI: 'Liechtenstein',
    LT: 'Lithuania',
    LU: 'Luxembourg',
    LV: 'Latvia',
    MT: 'Malta',
    NL: 'Netherlands',
    NO: 'Norway',
    PL: 'Poland',
    PT: 'Portugal',
    RO: 'Romania',
    SE: 'Sweden',
    SI: 'Slovenia',
    SK: 'Slovakia',
    UA: 'Ukraine',
    TR: 'Türkiye',
    US: 'United States',
    CA: 'Canada',
    MX: 'Mexico',
    BR: 'Brazil',
    CL: 'Chile',
    AR: 'Argentina',
    PE: 'Peru',
    CO: 'Colombia',
    CN: 'China',
    HK: 'Hong Kong',
    TW: 'Taiwan',
    JP: 'Japan',
    KR: 'South Korea',
    SG: 'Singapore',
    IN: 'India',
    ID: 'Indonesia',
    MY: 'Malaysia',
    TH: 'Thailand',
    PH: 'Philippines',
    VN: 'Vietnam',
    AU: 'Australia',
    NZ: 'New Zealand',
    ZA: 'South Africa',
    NG: 'Nigeria',
    KE: 'Kenya',
    GH: 'Ghana',
    EG: 'Egypt',
    MA: 'Morocco',
    AE: 'United Arab Emirates',
    SA: 'Saudi Arabia',
    QA: 'Qatar',
    IL: 'Israel',
  },
)
export type CountryCode = (typeof COUNTRIES.values)[number]
